import { Box, Typography } from "@mui/material";
import React from "react";
import { SectionBoxStyles } from "./SectionBoxStyles";
import {useTheme} from "@mui/material/styles";

const SectionBox = ({
  textBeside,
  icon,
  onClick,
  iconFontSize,
  iconColor,
  iconBorderColor,
  iconMarginRight,
  boxbackgroundColor,
  boxTitleVariant,
}) => {
  let IconComponent = icon;
  const theme = useTheme();
  return (
    <SectionBoxStyles
      iconFontSize={iconFontSize||theme.spacing(8)}
      iconColor={iconColor}
      iconBorderColor={iconBorderColor}
      boxbackgroundColor={boxbackgroundColor}
      iconMarginRight={iconMarginRight}
      cursor='pointer'
      onClick={onClick}
    >
      {IconComponent && <IconComponent fontSize="large" className="icon" />}
      <Box className="textContainer">
        <Typography className="title" variant={boxTitleVariant || "h5"}>
          {textBeside}
        </Typography>
      </Box>
    </SectionBoxStyles>
  );
};

export default SectionBox;
